import {createFileRoute} from '@tanstack/react-router';
import {OpenBankingDisbursementCallbackPage} from 'features/deposit/withdrawal/OpenBankingDisbursementCallbackPage';

export const Route = createFileRoute(
  '/_protected/withdrawal/openbanking/callback',
)({
  component: OpenBankingDisbursementCallbackPage,
  validateSearch: (search) => {
    return {
      accountId: search.accountId as string | undefined,
      accountNumber: search.accountNumber as string | undefined,
      status: search.status as string | undefined,
    };
  },
});
